import React, { useState } from 'react'
import ModelComponent from '../../../components/Modal'
import { Button, Col, Row } from 'react-bootstrap'
import { getBaseUrl, getDeviceId, getUserToken } from '../../../lib/GetBaseUrl'
import FileSaver from 'file-saver'
import Loader from '../../../components/Loader'
import { useImmer } from 'use-immer'
import moment from 'moment'
import { DatePicker } from 'antd'
import { showToast } from '../../../lib/AllGlobalFunction'
import CustomToast from '../../../components/Toast/CustomToast'

const SellerReport = ({ modalShow, setModalShow }) => {
  const [loading, setLoading] = useState(false)
  const [filterDetails, setFilterDetails] = useImmer({
    sellerId: '',
    fromDate: '',
    toDate: '',
    errors: ''
  })
  const [toast, setToast] = useState({
    show: false,
    text: null,
    variation: null
  })

  const download = async () => {
    if (filterDetails?.fromDate && filterDetails?.toDate) {
      setFilterDetails((draft) => {
        draft.errors = ''
      })
      setLoading(true)
      let headers = new Headers()
      headers.append('Authorization', `Bearer ${getUserToken()}`)
      headers.append('device_id', `${getDeviceId()}`)
      let downloadUrl = `${getBaseUrl()}/Reports/SellerReport?fromDate=${
        filterDetails?.fromDate
          ? filterDetails?.fromDate?.format('DD-MM-YYYY')
          : ''
      }&toDate=${
        filterDetails?.toDate ? filterDetails?.toDate?.format('DD-MM-YYYY') : ''
      }`
      fetch(downloadUrl, {
        method: 'GET',
        headers: headers
      })
        .then((response) => {
          setLoading(false)
          const blob = response.blob()
          return blob
        })
        .then((blob) => {
          const customFileName = 'seller report.xlsx'
          FileSaver.saveAs(blob, customFileName)
        })
    } else {
      showToast(toast, setToast, {
        data: {
          message: 'Please select start date and end date',
          code: 204
        }
      })
      setFilterDetails((draft) => {
        draft.errors = 'Please select start date and end date'
      })
    }
  }

  const disabledDate = (current) => {
    const startDate = moment('2023-01-01')
    const today = moment().endOf('day')

    return current && (current < startDate || current > today)
  }

  const disabledEndDate = (current, startValue) => {
    const today = moment().endOf('day')

    if (
      startValue &&
      (current.isBefore(startValue.startOf('day')) || current.isAfter(today))
    ) {
      return true
    }

    return false
  }

  return (
    <ModelComponent
      show={modalShow.report}
      modalsize={'md'}
      className='fade-modal-for-date modal-backdrop'
      modalheaderclass={''}
      modeltitle={'Seller Report'}
      onHide={() => {
        setModalShow((draft) => {
          draft.report = false
        })
      }}
      btnclosetext={''}
      closebtnvariant={''}
      backdrop={'static'}
    >
      <Row className='gy-3 align-items-center'>
        {loading && <Loader />}
        <Col md={4}>
          <DatePicker
            className='w-100 pv-datepicker'
            inputReadOnly
            format='DD-MM-YYYY'
            placeholder='From date'
            // showTime={{ format: 'HH:mm:ss' }}
            onChange={(date) => {
              setFilterDetails((draft) => {
                draft.fromDate = date
                draft.toDate = ''
                draft.errors = ''
              })
            }}
            disabledDate={disabledDate}
            // disabledTime={disabledTime}
            value={filterDetails?.fromDate}
          />
        </Col>
        {filterDetails?.fromDate && (
          <Col md={4}>
            <DatePicker
              className='w-100 pv-datepicker'
              inputReadOnly
              format='DD-MM-YYYY'
              placeholder='To date'
              // showTime={{
              //   format: 'HH:mm:ss',
              //   disabledTime: () => values?.startDate
              // }}
              onChange={(date) => {
                setFilterDetails((draft) => {
                  draft.toDate = date
                  draft.errors = ''
                })
              }}
              disabledDate={(current) =>
                disabledEndDate(current, filterDetails?.fromDate)
              }
              value={filterDetails?.toDate}
            />
          </Col>
        )}
        <Col md={4}>
          <Button
            className='text-center w-100'
            variant='outline-primary'
            onClick={download}
          >
            Download
          </Button>
        </Col>

        {toast?.show && (
          <CustomToast text={toast?.text} variation={toast?.variation} />
        )}
      </Row>
    </ModelComponent>
  )
}
export default SellerReport
